<script setup>
import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">Datas</h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Envio para Aprovação</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemEnvioAprovacao"
                        :value="props?.dado?.naoTemEnvioAprovacao"
                        hide-details
                        disabled
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="props?.dado?.dataEnvioAprovacaoContratualFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataEnvioAprovacaoEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                     <h3>Aprovação</h3>

                     <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemAprovacao"
                        :value="props?.dado?.naoTemAprovacao"
                        hide-details
                        disabled
                    ></v-checkbox>


                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="props?.dado?.dataAprovacaoPrevistaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataAprovacaoEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Inspeção</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemInspecao"
                        :value="props?.dado?.naoTemInspecao"
                        hide-details
                        disabled
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="props?.dado?.dataInspecaoPrevistaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataInspecaoEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Entrega Fiscal</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemEntregaFiscal"
                        :value="props?.dado?.naoTemEntregaFiscal"
                        hide-details
                        disabled
                    ></v-checkbox>


                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="props?.dado?.dataEntregaFiscalPrevistaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataEntregaFiscalEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Montagem</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemMontagem"
                        :value="props?.dado?.naoTemMontagem"
                        hide-details
                        disabled
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="props?.dado?.dataMontagemContratualFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataMontagemEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Start-UP</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemStartup"
                        :value="props?.dado?.naoTemStartup"
                        hide-details
                        disabled
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="props?.dado?.dataStartupPrevistaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataStartupEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Entrega Final Contratual</h3>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="props?.dado?.dataFinalContratualFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="props?.dado?.dataFinalEfetivaFormatada"
                            prepend-icon="mdi-calendar" 
                            outlined
                            disabled
                            return-object
                        ></v-text-field>

                    </div>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-cartao__conteudo{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 20px;
}

.c-grupo{
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
    padding: 15px;
}

.c-grupo__titulo{
    display: grid;
    grid-template-rows: max-content max-content;
    grid-gap: 5px;
    padding: 0px 0px 15px 0px;
}

.c-grupo__acoes-edicao{
    display: flex;
    gap: 8px;
    align-items: center;
}

.mb-3{
    margin-bottom: 12px;
}

.c-titulo__checkbox{
    padding: 0px;
    margin: 0px;
    max-width: fit-content;
}

</style>